

















































import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";
import { SwiperModel } from "../models/swiper.model";
import AppSlide from "./AppSlide.vue";
import { SportEvent } from "../models/sport-events.model";
import AppStatusBadge from "@/components/Status/AppStatusBadge.vue";
import AppRegistrationStatusBadge from "@/components/Status/AppRegistrationStatusBadge.vue";
import { BButton } from "bootstrap-vue";

@Component({
  name: "AppSportEventSlide",
  extends: AppSlide,
  components: { AppStatusBadge, AppRegistrationStatusBadge, BButton }
})
export default class extends Vue {
  @Prop({ required: true }) sportEvent!: SportEvent;

  get isEventEnded() {
    return this.sportEvent.status.code === "end";
  }
}
